import React, { useState } from "react"
import { Link } from "gatsby"
import SEO from "../components/SEO"

import { blogs } from "../data/blogs"

const POSTS_PER_PAGE = 6

export default function Blog({ location }) {
  const [currentPage, setCurrentPage] = useState(1)

  const sortedBlogs = [...blogs].sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  )

  const totalPages = Math.ceil(sortedBlogs.length / POSTS_PER_PAGE)
  const startIndex = (currentPage - 1) * POSTS_PER_PAGE
  const visibleBlogs = sortedBlogs.slice(startIndex, startIndex + POSTS_PER_PAGE)

  const goToPage = page => {
    setCurrentPage(page)

    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" })
    }
  }

  return (
    <div>
      <style>
        {`
          .row.justify-content-center.align-items-stretch.g-3.gx-lg-0 {
            display: none !important;
          }

          #blog {
            display: none !important;
          }

          .blog-grid {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            gap: 28px;
            margin-top: 35px;
          }

          .blog-card {
            background: #fff;
            border: 1px solid #dfecee;
            border-radius: 14px;
            overflow: hidden;
            box-shadow: 0 14px 35px rgba(12, 68, 72, 0.07);
          }

          .blog-card img {
            width: 100%;
            height: 190px;
            object-fit: cover;
            display: block;
          }

          .blog-card-content {
            padding: 22px;
          }

          .blog-card h2 {
            font-size: 21px;
            line-height: 1.3;
            margin-bottom: 12px;
          }

          .blog-card h2 a {
            color: #08777f;
            text-decoration: none;
          }

          .blog-card p {
            color: #34484b;
            line-height: 1.6;
            margin-bottom: 18px;
          }

          .blog-card small {
            color: #08777f;
            font-weight: 700;
          }

          .blog-pagination {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 10px;
            margin-top: 34px;
            flex-wrap: wrap;
          }

          .blog-pagination button {
            width: 42px;
            height: 42px;
            border: 1px solid #08777f;
            border-radius: 6px;
            background: #fff;
            color: #08777f;
            font-weight: 700;
            cursor: pointer;
            transition: background 0.2s ease, color 0.2s ease;
          }

          .blog-pagination button:hover,
          .blog-pagination button.active {
            background: #08777f;
            color: #fff;
          }

          .blog-pagination button:disabled {
            cursor: not-allowed;
            opacity: 0.45;
          }

          @media (max-width: 992px) {
            .blog-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }

          @media (max-width: 576px) {
            .blog-grid {
              grid-template-columns: 1fr;
            }
          }
        `}
      </style>

      <SEO location={location} title="Chiropractic Blog | Urban Care Chiropractic" description="Explore chiropractic tips, pain relief guidance, posture advice, and wellness insights from Urban Care Chiropractic in West Loop, Chicago." />

      <section className="container my-5 px-3 page-content">
        <h1>Blog</h1>

        <div className="blog-grid">
          {visibleBlogs.map(blog => (
            <article className="blog-card" key={blog.link}>
              <Link to={blog.link}>
                <img src={blog.image} alt={blog.title} />
              </Link>

              <div className="blog-card-content">
                <h2>
                  <Link to={blog.link}>{blog.title}</Link>
                </h2>

                <p>{blog.excerpt}</p>
                <small>{blog.date} | By Dr. Kenny Snook</small>
              </div>
            </article>
          ))}
        </div>

        {totalPages > 1 && (
          <nav className="blog-pagination" aria-label="Blog pagination">
            <button
              type="button"
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous page"
            >
              &lt;
            </button>

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1

              return (
                <button
                  type="button"
                  key={page}
                  className={currentPage === page ? "active" : ""}
                  onClick={() => goToPage(page)}
                  aria-current={currentPage === page ? "page" : undefined}
                >
                  {page}
                </button>
              )
            })}

            <button
              type="button"
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next page"
            >
              &gt;
            </button>
          </nav>
        )}
      </section>
    </div>
  )
}
